import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { BarChart } from '@mui/x-charts/BarChart';
import type React from 'react';

interface MonthlyBarChartProps {
  title: string;
  data: Array<{ label: string; value: number }>;
  yAxisLabel?: string;
  yAxisMin?: number;
  color?: string;
  height?: number;
  emptyMessage?: string;
}

const MonthlyBarChart: React.FC<MonthlyBarChartProps> = ({
  title,
  data,
  yAxisLabel,
  yAxisMin,
  color,
  height = 350,
  emptyMessage = 'No hay datos disponibles',
}) => {
  const theme = useTheme();

  return (
    <Card sx={{ height: '100%', borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
          {title}
        </Typography>
        {data.length > 0 ? (
          <BarChart
            series={[
              {
                data: data.map((d) => d.value),
                color: color || theme.palette.primary.main,
              },
            ]}
            xAxis={[
              {
                data: data.map((d) => d.label.substring(0, 3)),
                scaleType: 'band',
              },
            ]}
            height={height}
            margin={{ top: 20, bottom: 40, left: yAxisLabel ? 90 : 60, right: 20 }}
            yAxis={
              yAxisLabel || yAxisMin !== undefined
                ? [
                    {
                      ...(yAxisLabel ? { label: yAxisLabel } : {}),
                      ...(yAxisMin !== undefined ? { min: yAxisMin } : {}),
                    },
                  ]
                : undefined
            }
            sx={{
              '& .MuiChartsAxis-tickLabel': {
                fontSize: '12px',
              },
            }}
            hideLegend={true}
          />
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height }}>
            <Typography
              sx={{
                color: 'text.secondary',
              }}
            >
              {emptyMessage}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default MonthlyBarChart;
